<!-- <p>pending-complaints works!</p> -->
<div style="text-align: right; padding: 10px 20px;">

  <a routerLink="/sdp/officer/dashboard" class="hover-blue"
    style="text-decoration: underline; color: rgb(24, 107, 202); font-weight: 500; font-size: 20px;">
    < &nbsp; Back
  </a>
</div>
<!-- <div class="row pt-3 px-3"> -->
<!-- <div class="col-12"> -->
<div class="container-fluid px-3" style="overflow-x:auto;">
  <div class="row">
    <div class="col-12 header-col">
      <div class="header1">
        <div style="margin: 0; padding: 0;">
          <h2>Ticket Id :{{updateData['ticket_id']}}</h2>
          <p>Filled On :{{updateData['create_date']}}</p>
        </div>
        <div>
          <mat-chip color="warn" class="status-chip">
            <span style="color: rgb(65, 50, 33); background-color:#FEF3C7; padding: 7px;">
              {{updateData['status']}}
            </span>
          </mat-chip>
        </div>
        <div class="actions">
          <button  class="hover-light" style="background-color: #226CE0; color: white;" mat-raised-button
            (click)="openUpdateDialog(updateData)"><span>Update Status</span></button>
        </div>
      </div>
      <div class="complaints-details my-3"><span
          style="background-color: #FFFFFF; color: #000000; padding: 5px;">Complaints Details</span></div>
    </div>
  </div>

  <div class="content pt-5" style="display: flex; flex-wrap: wrap;">
    <div class="left-section">
      <mat-card class=" pt-3" style="padding: 20px; height: fit-content;">
        <p>
          <span style="font-weight: bold; font-size: 20px;" class="complaints-information">Complaints
            Information</span><br>
          Details of the Complaints as reported by {{updateData.mohalla}}.
        </p>
        <p><strong>Description:</strong><br> {{updateData.complaint_desc}}</p>
        <div style="display: flex;">
          <p><strong>Department:</strong><br> {{updateData.departments}}</p>
          <p style="margin-left: 100px;" class="zone"><strong>Zone</strong><br>{{updateData.zone}}</p>
        </div>
        <!-- <div style="text-align: end;" class="px-4">
        <mat-chip color="warn">
          SLA Status <br><span style="color: #F52525;">
            <div class="warning-icon">
              <mat-icon>warning</mat-icon>
              SLA Breached (776 days)
            </div>
          </span>
        </mat-chip>
      </div> -->
      </mat-card>
    </div>
    <div class="right-section">
      <mat-card class="info-card">
        <h5><b>Citizen Information</b></h5>
        <div class="person-outline">
          <mat-icon>person_outline</mat-icon>
          <div>
            {{updateData.full_name}} <br>
          </div>
        </div>
        <!-- &nbsp;&nbsp; -->
        <p style="padding-left: 10px;">Contact Number:<br><b>{{updateData.mobile_no}}</b></p>
        <button mat-stroked-button disabled>
          <mat-icon>message</mat-icon>
          Contact Citizen
        </button>
      </mat-card>

      <!-- <mat-card class="info-card">
        <h5><b>SLA Information</b></h5>
        <p><strong>Expected Resolution:</strong><br>{{updateData.valid_upto}}</p>
        <p>Time Remaining <br><span class="sla-warning">SLA Breached by 773 days</span></p>
      </mat-card> -->
    </div>
  </div>
</div>
<!-- </div> -->
<!-- </div> -->